// extracted by mini-css-extract-plugin
export default {"aboutMe":"Introduction_aboutMe__lityx","imgDiv":"Introduction_imgDiv__VpZ0O","profilephoto":"Introduction_profilephoto__WN73K","popUpImage":"Introduction_popUpImage__1HMpc"};